var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 15.3333C3.93341 15.3333 0.666748 12.0667 0.666748 7.99999C0.666748 3.93332 3.93341 0.666656 8.00008 0.666656C12.0667 0.666656 15.3334 3.93332 15.3334 7.99999C15.3334 12.0667 12.0667 15.3333 8.00008 15.3333ZM8.00008 1.99999C4.66675 1.99999 2.00008 4.66666 2.00008 7.99999C2.00008 11.3333 4.66675 14 8.00008 14C11.3334 14 14.0001 11.3333 14.0001 7.99999C14.0001 4.66666 11.3334 1.99999 8.00008 1.99999Z",
    fill: "#F9774E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 8.66666C7.60008 8.66666 7.33341 8.39999 7.33341 7.99999V5.33332C7.33341 4.93332 7.60008 4.66666 8.00008 4.66666C8.40008 4.66666 8.66675 4.93332 8.66675 5.33332V7.99999C8.66675 8.39999 8.40008 8.66666 8.00008 8.66666Z",
    fill: "#F9774E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 11.3333C7.80008 11.3333 7.66675 11.2667 7.53341 11.1333C7.40008 11 7.33341 10.8667 7.33341 10.6667C7.33341 10.6 7.33341 10.4667 7.40008 10.4C7.46675 10.3333 7.46675 10.2667 7.53341 10.2C7.73341 9.99999 8.00008 9.93332 8.26675 10.0667C8.33341 10.0667 8.33341 10.0667 8.40008 10.1333C8.40008 10.1333 8.46675 10.2 8.53341 10.2C8.60008 10.2667 8.66675 10.3333 8.66675 10.4C8.66675 10.4667 8.66675 10.6 8.66675 10.6667C8.66675 10.7333 8.66675 10.8667 8.60008 10.9333C8.53341 11 8.53341 11.0667 8.46675 11.1333C8.33341 11.2667 8.20008 11.3333 8.00008 11.3333Z",
    fill: "#F9774E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.cb127c17297ef5130fa31adfe8bff019.svg";
export { ForwardRef as ReactComponent };